import React from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Label,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Modal from "react-bootstrap/Modal"
import { useState } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import { addBannerSetSchema } from "components/Common/validation"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import {
  addBanner,
  deleteBanner,
  deleteSlide,
  getAllBanners,
  getBannerDetails,
  updateBanner,
  updateBannerStatus,
  updateSlideStatus,
} from "store/actions/bannerAction"
import { useEffect } from "react"
import DeleteModal from "components/Common/DeleteModal"
import Switch from "components/Shared/Switch"
import { useLocation, useNavigate } from "react-router-dom"
import { showAlert } from "store/reducers/alertReducer"
import isPermissionEnabled from "common/isPermissionEnabled"
import { ShimmerThumbnail } from "react-shimmer-effects"
import Paginations from "components/Common/Paginations"
import { useTranslation } from "react-i18next"
import { getCountryList } from "store/actions/countriesAction"
import Select from "react-select"
import Filters from "components/Common/Filters"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import TextError from "components/Shared/TextError"

const initialValues = { name: "", nameAr: "", countryCode: "" }

const Banners = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Banners | Namq")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { countryList } = useSelector(state => state.Countries)

  const {
    loading,
    isLoading,
    isUpdating,
    actionType,
    totalCount,
    totalPages,
    itemsPerPage,
    currentPage,
    bannerLists,
    bannerDetails,
  } = useSelector(state => state.Banners)

  const { userRole, accountType } = useSelector(state => state.Login)
  const location = useLocation()

  const [formValues, setFormValues] = useState(initialValues)
  const searchParams = new URLSearchParams(location.search)
  const [show, setShow] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [modalType, setModalType] = useState(null)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedSlideId, setSelectedSlideId] = useState(null)
  const [selectedSlideBannerId, setSelectedSlideBannerId] = useState(null)
  const [showSlideDeleteModal, setShowSlideDeleteModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [isApiCalled, setIsApiCalled] = useState(false)

  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    countryCode: [],
  })

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  useEffect(() => {
    fetchCountryList()
  }, [])

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(userRole, 2, "inAppContent_1")
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      2,
      "inAppContent_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(userRole, 2, "inAppContent_3")
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      2,
      "inAppContent_4",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  const handleClose = () => {
    setShow(false)
    setFormValues({
      name: "",
      nameAr: "",
      countryCode: "",
    })
  }
  const handleShow = () => setShow(true)

  useEffect(() => {
    fetchBanners()
  }, [])

  const fetchBanners = () => {
    const { status, sortOrder } = selectedFilters

    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: status,
      orderBy: sortOrder,
      keyword: "",
      // countryCode: ["IN"],
    }
    dispatch(getAllBanners(payload))
    setIsApiCalled(true)
  }

  const filters = [
    {
      name: "status",
      type: "select",
      options: [
        { label: t("All"), value: 2 },
        { label: t("Active"), value: 1 },
        { label: t("Deactive"), value: 0 },
      ],
      placeholder: t("All"),
    },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
    {
      name: "countryCode",
      type: "multiSelect",
      options: [
        // { label: "All", value: "" },
        ...countryList.map(item => ({
          label: language === "sa" ? item.nameAr : item.name,
          value: item.countryCode,
        })),
      ],
      placeholder: t("Select Countries"),
    },
  ]

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleAddBannerSet = (values, { resetForm }) => {
    const { name, nameAr, countryCode } = values
    const updatedCountryCode = countryCode.value

    if (modalType === "ADD_BANNER") {
      const payload = {
        name,
        nameAr,
        countryCode: updatedCountryCode,
      }
      dispatch(addBanner({ ...payload, handleClose }))
    } else if (modalType === "EDIT_BANNER") {
      const payload = {
        id: selectedId,
        name,
        nameAr,
        countryCode: updatedCountryCode,
      }
      dispatch(updateBanner({ ...payload, handleClose }))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  const handleEditBanner = id => {
    setModalType("EDIT_BANNER")
    handleShow()
    const payload = {
      id,
    }
    dispatch(getBannerDetails(payload))
  }

  useEffect(() => {
    if (
      actionType === "GET_BANNER_DETAILS_SUCCESS" &&
      !isLoading &&
      modalType === "EDIT_BANNER"
    ) {
      const { name, nameAr, countryCode } = bannerDetails
      let updatedCountryCode = {}
      const matchedCountry = countryList.find(
        item => item.countryCode === countryCode
      )
      if (matchedCountry) {
        updatedCountryCode = {
          label: matchedCountry.name,
          value: matchedCountry.countryCode,
        }
      } else {
        updatedCountryCode = {}
      }

      setFormValues(prevValues => ({
        ...prevValues,
        name,
        nameAr,
        countryCode: updatedCountryCode,
      }))
    }
  }, [actionType, bannerDetails, isLoading, modalType])

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // for delete
    }
    dispatch(deleteBanner({ ...payload, setShowDeleteModal }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleBannerStatus = (id, status) => {
    setSelectedId(id)
    const payload = {
      id,
      status: status === 1 ? "0" : "1", //deactive 1 active
    }
    dispatch(updateBannerStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleSlideStatusClick = (id, status, bannerId) => {
    setSelectedSlideId(id)
    const payload = {
      id,
      status: status === 1 ? "0" : "1", //deactive 1 active
    }
    dispatch(updateSlideStatus({ ...payload, bannerId }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleSlideDelete = () => {
    const payload = {
      id: selectedSlideId,
      status: "2", // for delete
    }
    dispatch(
      deleteSlide({
        ...payload,
        selectedSlideBannerId,
        setShowSlideDeleteModal,
      })
    )
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const getApiCall = (page = 1) => {
    const { status, sortOrder, countryCode } = selectedFilters
    const updatedCode = countryCode?.map(item => item.value) || []

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      countryCode: updatedCode,
    }

    return dispatch(getAllBanners(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/banners?page=${page}`)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const handleSearch = () => {
    getApiCall(1)
  }

  const onPageChange = page => {
    getApiCall(page)
  }

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, selectedFilters])

  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: 1,
      status: 2,
      orderBy: 1,
      keyword: "",
      countryCode: [],
    }
    dispatch(getAllBanners(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/banners?page=${1}`)
        }
      })
      .catch(error => {})
    setSelectedFilters({ status: 2, sortOrder: 1, countryCode: [] })
    setSearchTerm("")
  }

  return (
    <div className="page-content banners_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Col md={12}>
          <Card>
            <DataExportDropdown
              cardTitle={t("Banners List")}
              isAddBtn={loading ? false : usersPermissions.create}
              addBtnText={t("Add Banner Set")}
              onAddBtnClick={() => {
                handleShow()
                setModalType("ADD_BANNER")
              }}
            />
            <CardBody>
              <Filters
                filters={filters}
                searchTerm={searchTerm}
                handleSearchChange={handleSearchChange}
                handleFilterChange={handleFilterChange}
                onReset={handleReset}
                handleSearch={handleSearch}
                handleReset={handleReset}
                selectedFilters={selectedFilters}
                searchBy={t("Name")}
              />
            </CardBody>
          </Card>
        </Col>
        <Row>
          {loading ? (
            <>
              <ShimmerThumbnail height={300} rounded />
              <div className="mt-3"></div>
              <ShimmerThumbnail height={300} rounded />
            </>
          ) : bannerLists.length === 0 ? (
            <p className="text-center my-2">{t("No banners found")}</p>
          ) : (
            bannerLists.map(
              ({ _id, name, nameAr, status, slides, countryCode }, index) => (
                <Col md={12} key={_id}>
                  <Card style={{ height: "93.5%" }}>
                    <CardBody>
                      <CardTitle className="mb-3">
                        <div className="d-flex justify-content-start align-items-center">
                          <span className="me-3">
                            {language === "sa" ? nameAr : name}
                          </span>
                          {usersPermissions.edit && (
                            <Switch
                              isChecked={status}
                              onClickHandler={() =>
                                handleBannerStatus(_id, status)
                              }
                              disabled={_id === selectedId && isUpdating}
                            />
                          )}
                          {usersPermissions.edit && (
                            <>
                              <i
                                id={`edittooltip_${_id}`}
                                onClick={() => {
                                  handleEditBanner(_id)
                                  setSelectedId(_id)
                                }}
                                className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                              ></i>
                              <UncontrolledTooltip
                                placement="top"
                                target={`edittooltip_${_id}`}
                              >
                                {t("Edit")}
                              </UncontrolledTooltip>
                            </>
                          )}
                          {usersPermissions.delete && (
                            <>
                              <i
                                id={`deletetooltip_${_id}`}
                                onClick={() => {
                                  setItemIdToDelete(_id)
                                  setShowDeleteModal(true)
                                }}
                                className="bx bxs-trash font-size-18 mx-2 cursor-pointer"
                                style={{ color: "#FD5F62" }}
                              ></i>
                              <UncontrolledTooltip
                                placement="top"
                                target={`deletetooltip_${_id}`}
                              >
                                {t("Delete")}
                              </UncontrolledTooltip>
                            </>
                          )}
                        </div>
                      </CardTitle>
                      <div className="mb-4">
                        {usersPermissions.create && (
                          <Button
                            color="success"
                            className="mx-1"
                            onClick={() =>
                              navigate(
                                `/banners/${_id}/slides/add?countryCode=${countryCode}`
                              )
                            }
                          >
                            {t("Add Slide")}
                          </Button>
                        )}
                      </div>
                      <div className="slides">
                        {slides &&
                          slides.map(
                            ({
                              _id,
                              imageUrl,
                              imageUrlAr,
                              status,
                              bannerGroup,
                            }) => (
                              <div
                                className="position-relative single_banner"
                                key={_id}
                              >
                                <img
                                  src={
                                    language === "sa" ? imageUrlAr : imageUrl
                                  }
                                  alt=""
                                  className="slide_img cursor-pointer rounded pt-1"
                                  onClick={() => {
                                    navigate(
                                      `/banners/${bannerGroup}/slides/edit?id=${_id}&countryCode=${countryCode}`
                                    )
                                  }}
                                />
                                <div className="d-flex justify-content-between align-items-center px-1 mt-2">
                                  {usersPermissions.edit && (
                                    <div>
                                      <Switch
                                        isChecked={status}
                                        onClickHandler={() => {
                                          handleSlideStatusClick(
                                            _id,
                                            status,
                                            bannerGroup
                                          )
                                        }}
                                        disabled={
                                          _id === selectedSlideId && isUpdating
                                        }
                                      />
                                    </div>
                                  )}
                                  {usersPermissions.delete && (
                                    <button
                                      className="transparent_btn"
                                      onClick={() => {
                                        setShowSlideDeleteModal(true)
                                        setSelectedSlideId(_id)
                                        setSelectedSlideBannerId(bannerGroup)
                                      }}
                                    >
                                      <i className="bx bx-trash-alt delete_icon"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )
            )
          )}
        </Row>
        {!loading && bannerLists.length > 0 && (
          <Row>
            <Card>
              <CardBody>
                <Paginations
                  data={bannerLists}
                  itemsPerPage={itemsPerPage}
                  onPageChange={onPageChange}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalCount={totalCount}
                />
              </CardBody>
            </Card>
          </Row>
        )}
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "ADD_BANNER" ? t("Add") : t("Save")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {modalType === "EDIT_BANNER" && isLoading ? (
            // <p>Loading</p>
            <div className="d-flex justify-content-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <Formik
              initialValues={formValues}
              enableReinitialize={true}
              validationSchema={addBannerSetSchema}
              onSubmit={handleAddBannerSet}
            >
              {({ values, errors, touched, setFieldValue }) => (
                <Form>
                  <div className="form_field">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label mb-0"
                    >
                      <span className="text-danger">*</span>{" "}
                      {t("Name(English)")}
                    </Label>
                    <Field
                      name="name"
                      type="text"
                      placeholder={t("Name(English)")}
                      className={`form-control ${
                        touched.name && errors.name ? "is-invalid" : ""
                      }`}
                    />
                    <TextError name={"name"} />
                  </div>
                  <div className="form_field">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label mb-0"
                    >
                      <span className="text-danger">*</span>
                      {t("Name(عربي)")}
                    </Label>
                    <Field
                      name="nameAr"
                      type="text"
                      style={{ direction: "rtl" }}
                      placeholder={t("Name(عربي)")}
                      className={`form-control ${
                        touched.nameAr && errors.nameAr ? "is-invalid" : ""
                      }`}
                    />
                    <TextError name={"nameAr"} />
                  </div>
                  <div className="">
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className="col col-form-label mb-0"
                    >
                      <span className="text-danger">*</span>{" "}
                      {t("Select Country")}
                    </Label>
                    <Select
                      value={values.countryCode}
                      onChange={item => {
                        setFieldValue("countryCode", item)
                      }}
                      options={countryList?.map(item => ({
                        label: language === "sa" ? item.nameAr : item.name,
                        value: item.countryCode,
                      }))}
                      className={`select2-selection ${
                        touched.countryCode && errors.countryCode
                          ? "danger_color_border"
                          : ""
                      } `}
                      placeholder={t("Select Country")}
                    />
                    <TextError name={"countryCode"} />
                  </div>
                  <Button
                    color="success"
                    type="submit"
                    className="my-2 mt-4 ms-auto d-block"
                    disabled={isLoading || isUpdating}
                  >
                    {modalType === "ADD_BANNER" ? t("Add") : t("Save")}
                  </Button>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
        {/* )} */}
        <Modal.Footer></Modal.Footer>
      </Modal>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => {
          setItemIdToDelete(null)
          setShowDeleteModal(false)
        }}
        isLoading={isLoading}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this Banner?")}
      />
      <DeleteModal
        show={showSlideDeleteModal}
        onDeleteClick={handleSlideDelete}
        onCloseClick={() => {
          setShowSlideDeleteModal(false)
          setSelectedSlideId(null)
          setSelectedSlideBannerId(null)
        }}
        isLoading={isLoading}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this Slide?")}
      />
    </div>
  )
}

export default Banners
